export default __webpack_public_path__ + "118ba5993595a0b5f8e152787b5bd898.png";